export interface IImageResponse {
    imageUrl: string;
    errorMessage?: string;
}

export class ImageResponseClass implements IImageResponse {
    public imageUrl: string;
    public errorMessage?: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.imageUrl = odataObject.imageUrl;
        this.errorMessage = odataObject.errorMessage;
    }
}

export interface IProductTimeSlot {
    RecId: number;
    SlotName?: string;
    TimeSlots?: ITimeSlot[];
}

export interface ITimeSlot {
    Name?: string;
    ValueFrom?: string;
    ValueTo?: string;
}

export class TimeSlotClass implements TimeSlotClass {
    public Name: string;
    public ValueFrom: string;
    public ValueTo: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.Name = odataObject.Name;
        this.ValueFrom = odataObject.ValueFrom;
        this.ValueTo = odataObject.ValueTo;
    }
}

export class ProductTimeSlotsResponse implements IProductTimeSlot {
    public RecId: number;
    public SlotName?: string;
    public TimeSlots?: ITimeSlot[];

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.RecId = odataObject.RecId ? parseInt(odataObject.RecId, 10) : 0;
        this.SlotName = odataObject.SlotName;
        this.TimeSlots = [];
        if (odataObject.TimeSlots) {
            for (var i = 0; i < odataObject.TimeSlots.length; i++) {
                if (odataObject.TimeSlots[i]) {
                    this.TimeSlots[i] = new TimeSlotClass(odataObject.TimeSlots[i]);
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.TimeSlots[i] = undefined;
                }
            }
        }
    }
}
